import { Stack, Typography } from '@mui/material';
import { DateField } from 'components/DateField/DateField';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { SignupFormData, SignUpUserType } from 'features/signUp/types';

interface DobEligibilityCheckStepProps {
  signUpUserType: SignUpUserType;
}

export const DobEligibilityCheckStep = ({ signUpUserType }: DobEligibilityCheckStepProps) => {
  const { translation } = useTranslationContext();
  const {
    register,
    formState: { errors },
  } = useFormContext<SignupFormData>();

  const { ref, onChange, onBlur, name, required } = register('memberDateOfBirth', {
    required: translation('empty_field_error'),
  });

  return (
    <Stack id="dob-eligibility-check__wrapper">
      <Typography variant="h5" color="primary" id="dob-eligibility-check__header" mb={3}>
        {signUpUserType === 'member'
          ? translation('eligibility_dob_header')
          : translation('eligibility_dob_caregiver_header')}
      </Typography>
      <DateField
        id="dob-eligibility-check__dob-input"
        label={translation('date_of_birth')}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        inputRef={ref}
        error={!!errors.memberDateOfBirth}
        helperText={errors.memberDateOfBirth?.message}
      />
    </Stack>
  );
};
